import { render, staticRenderFns } from "./GridScattered.vue?vue&type=template&id=6d61a2da&lang=pug&"
import script from "./GridScattered.vue?vue&type=script&lang=js&"
export * from "./GridScattered.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports